import React, { Component } from 'react';


class Cliente extends Component {
    constructor(props) {
        super(props);
    }

    render() {

        return (
            <div key={this.props.prom.Id} onClick={()=>this.props.seleccionarPromotor(this.props.prom.Id)} className={"ti-user  color-persona-fisica busquedaPromotorSeparador"} aria-hidden="true">
                <span className="busquedaPromotorFuente"> {this.props.prom.Descripcion}</span>
            </div>
        );
    }
};
export default Cliente;